<template>
	<router-view />
</template>

<script>
export default {
	name: 'App',
	metaInfo () {
		return {
			titleTemplate: '%s / ' + this.title
		}
	},
	data () {
		return {
			title: process.env.VUE_APP_TITLE,
		}
	}
}
</script>
